// extracted by css-extract-rspack-plugin
export default {"infoRow":"infoRow-rRcGFt","spacer":"spacer-iNitul","links":"links-UU60GS","detailRow":"detailRow-PdpQlw","detailIcon":"detailIcon-o9b9wS"};